import { Tooltip, tooltipClasses, styled, Box, Typography, Divider } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { fontLink, isArray } from "../base";
import React from "react";

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip
        enterTouchDelay={0}
        enterDelay={100}
        enterNextDelay={200}
        {...props}
        arrow={false}
        classes={{ popper: className }}
        slotProps={{
            popper: {
                modifiers: [
                    {
                        name: 'preventOverflow',
                        options: {
                            padding: 8,
                        },
                    },
                ],
                sx: {
                    pointerEvents: 'auto !important',
                    zIndex: 9999,
                },
            },
            tooltip: {
                onTouchStart: (e) => {
                    e.stopPropagation();
                },
                onTouchMove: (e) => {
                    e.stopPropagation();
                },
            },
        }}
    />
))(() => ({
    zIndex: 9999,
    pointerEvents: 'auto',
    [`& .${tooltipClasses.tooltip}`]: {
        background: "linear-gradient(135deg, #5B3CC4, #3B2DA6)",
        color: "#fff",
        maxWidth: '280px',
        minWidth: '200px',
        padding: 16,
        borderRadius: 12,
        boxShadow: "0px 10px 30px rgba(0,0,0,0.25)",
        ...fontLink,

        pointerEvents: 'auto',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: "#3B2DA6",
    },
    [`& .${tooltipClasses.popper}`]: {
        zIndex: 9999,
        pointerEvents: 'auto',
    },
}));

const TextContent = ({ text, hideLine }) => <>
    {!hideLine && <Divider sx={{ my: 2, opacity: 1, bgcolor: 'white', height: '2px' }} />}
    <Typography sx={{ fontFamily: 'inter', fontWeight: 400, ...fontLink, maxWidth: '400px', color: '#fff', }}>
        {text}
    </Typography>
</>

export const InfoTooltipContent = ({ title, text, hideLine }) => {
    if (!title && !text) return <></>;
    return (
        <Box
            onTouchStart={(e) => e.stopPropagation()}
            onTouchMove={(e) => e.stopPropagation()}
            onClick={(e) => e?.stopPropagation()}
        >
            {title && <>
                <Box display="flex" alignItems="center" gap={1}>
                    <InfoOutlinedIcon fontSize="small" />
                    <Typography sx={{ fontFamily: 'inter', fontWeight: 700, ...fontLink, maxWidth: '400px', color: '#fff', }}>
                        {title}
                    </Typography>
                </Box>

            </>}
            {isArray(text) ? <>
                {text.map((t, i) => <TextContent key={'TotT' + i} text={t} hideLine={hideLine} />)}
            </> : <><TextContent text={text} hideLine={hideLine} /></>}


        </Box>
    )
};

export default function InfoTooltip({ children, sxIcon = {}, hide, hideLine = false, tooltip, ...props }) {
    const { title, text, ...rest } = props;

    if (tooltip === true || (!title && !text)) return <>{children ? children : <InfoRoundedIcon sx={{ color: '#D6D6D6', width: '24px', height: '24px', cursor: 'pointer', ...sxIcon }} />}</>
    return (
        <CustomTooltip open={hide ? false : undefined} {...rest} title={<InfoTooltipContent title={title} text={text} hideLine={hideLine}
        />}>

            {children ? children : <InfoRoundedIcon sx={{
                color: '#D6D6D6', width: '24px', height: '24px', cursor: 'pointer',
                WebkitTapHighlightColor: "transparent",
                WebkitTouchCallout: "none",
                userSelect: "none", display: 'block', ...sxIcon
            }} />}

        </CustomTooltip>
    )
}
